<template style="height:100%">
  <div class="Add_factor_problem">
    <el-form label-width="80px" style="padding-top: 20px;margin-left: 20px;">
      <el-form-item label="量表名称">
        <el-input placeholder="量表名称" v-model="papername" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>

      <el-form-item label="上一级答案">
        <el-select v-model="panswerID" placeholder="请选择因子名称" @change="getinfo()">
          <el-option v-for="(item,i) in options" :key="i" :label="item.questionName" :value="item.panswerID">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="题目顺序号">
        <el-select v-model="questionID" placeholder="请选择题目顺序号" @change="getinfo()">
          <el-option v-for="(item,i) in options2" :key="i" :label="item.lineNumber +item.questionName" :value="item.questionID">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="答案名称">
        <el-input v-model="answerName" placeholder="答案名称"></el-input>
      </el-form-item>

      <el-form-item label="答案字母代号">
        <el-input v-model="letterNumber" placeholder="答案字母代号"></el-input>
      </el-form-item>

      <el-form-item label="答案分值(正向)">
        <el-input v-model="answerScore" placeholder="答案分值(正向)"></el-input>
      </el-form-item>

      <el-form-item label="答案分值(反向)">
        <el-input v-model="answerScoreR" placeholder="答案分值(反向)"></el-input>
      </el-form-item>

      <el-form-item label="答案结论">
        <el-input v-model="result" placeholder="答案结论"></el-input>
      </el-form-item>

      <el-form-item label="答案排序">
        <el-input v-model="lineNumber" placeholder="答案排序"></el-input>
      </el-form-item>

      <el-form-item label="答案显示方式">
        <el-radio-group v-model="answerType" placeholder="答案显示方式">
          <el-radio label="0">文字</el-radio>
          <el-radio label="1">图片</el-radio>
          <el-radio label="2">叙述</el-radio>
          <el-radio label="3">填空</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="上传图片" style="height: 180px;">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
      </el-form-item>

      <el-form-item label="子答案显示类型">
        <el-radio-group v-model="ansOptionType">
          <el-radio label="1">单选</el-radio>
          <el-radio label="2">多选</el-radio>
          <el-radio label="3">填空</el-radio>
          <el-radio label="4">叙述</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="答案描述">
        <el-input v-model="remark" placeholder="答案描述"></el-input>
      </el-form-item>

      <el-form-item label="标签">
        <el-input v-model="tagging" placeholder="标签"></el-input>
      </el-form-item>

      <el-form-item label="是否启用">
        <el-radio-group v-model="isActive">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-button v-if="pds" type="primary" @click="addfun(1)" style="margin-left:250px">确定</el-button>

      <el-button v-else type="primary" @click="addfun(2)" style="margin-left:250px">确定</el-button>

    </el-form>

    <el-dialog class="cscs" :visible.sync="dialogVisible" width="600px" style="height: 700px;" >
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>

  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
  export default {
    data() {
      return {
        imageUrl:'',
        imageFile:'',
        pds:true,
        papername:'',//量表名称
        paperID:'',//量表id
        panswerID:'',//父答案编号
        answerName:'',//答案名称
        letterNumber:'',//答案字母代号
        answerScore:'',//答案分值(正向)
        answerScoreR:'',//答案分值(反向)
        lineNumber:'',//答案排序
        answerType:'',//答案显示方式
        ansOptionType:'',//子答案显示类型
        remark:'',//答案描述
        tagging:'',//标签
        isActive:'1',//标签
        result:'',//标签
        questionID:'',//标签
        dialogVisible:false,
        options:[],
        options2:[],
        xgquestionID:'',
      };
    },
    components:{
      scales_Pop
    },
    methods: {
      getinfo(data){//根据因子获取数据

      },
      addfun(val){
        if(val == 1){
          var from = new FormData();
          from.append('imageFile',     this.imageFile.raw);
          from.append('questionID',       this.questionID);
          from.append('paperID',       this.paperID);
          from.append('panswerID',     this.panswerID);
          from.append('answerName',    this.answerName);
          from.append('letterNumber',  this.letterNumber);
          from.append('answerScore',   this.answerScore);
          from.append('answerScoreR',  this.answerScoreR);
          from.append('lineNumber',    this.lineNumber);
          from.append('answerType',    this.answerType);
          from.append('ansOptionType', this.ansOptionType);
          from.append('isActive',      this.isActive);
          from.append('remark',        this.remark);
          from.append('tagging',       this.tagging);
          from.append('result',        this.result);

          this.$Http_Post('paperconfig/answercfg/add', from, {'Content-Type':'multipart/form-data',}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }else{

        }
      },
      cel(){
        this.dialogVisible = true;
      },
      getmsg(val){//量表点击时子组件传过来值
        this.papername = val.label;
        this.paperID = val.val;
        this.$Http_Post('/paperconfig/answercfg/list', {paperCode:val.val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options = res.Data;
          }else{
            this.Global.request_failure(res.Message);
          }
        });

        this.$Http_Post('/paperconfig/questioncfg/list', {paperID:val.val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options2 = res.Data;
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      handleChange(file, fileList) {
        if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
          this.imageUrl = URL.createObjectURL(file.raw);
          this.imageFile = file;
        } else {
          this.$message({ type: 'error', message: '文件格式错误，请上传图片'})
        }
      },
    },
    mounted(){
      if([this.$route.query.paperID][0]){
        this.pds = false;
      }else{  
        this.pds = true;
      }
    }
  };
</script>
<style>
.Add_factor_problem {width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Add_factor_problem .el-input, .el-textarea{width: 500px;}
.Add_factor_problem .el-textarea__inner{height: 80px !important;}
.Add_factor_problem .el-form-item__label{width: 140px !important;}
.Add_factor_problem .avatar-uploader{left: 65px;}
</style>